import "./style.less";
import { trans } from "~/utils/trans";

export const MAX_DIFFICULTY = 5;

interface IDifficulty {
	// 1 - 5, 5 = nejslozitejsi
	value: number;
	showLabel?: boolean;
	// small = nenapadna varianta napr. do seznamu jidel, large = vyrazna napr. v nastaveni
	size?: "normal" | "small" | "large";
	// pokud je zadano, cepice jsou klikaci a vraci zvolenou slozitost
	onChange?: (value: number) => void;
}

function ChefHat({ filled }: { filled: boolean }) {
	return <svg className={`difficulty__hat ${filled ? "difficulty__hat--filled" : ""}`} viewBox="0 0 24 24" aria-hidden="true">
		<circle cx="7" cy="11" r="3.6" />
		<circle cx="12" cy="9.4" r="4.2" />
		<circle cx="17" cy="11" r="3.6" />
		<path d="M5.6 11.5h12.8l-.7 4H6.3z" />
		<rect x="6.3" y="16.6" width="11.4" height="2.8" rx="1" />
	</svg>;
}

export function getDifficultyLabel(value: number) {
	return value >= 1 && value <= MAX_DIFFICULTY ? trans(`difficulty.level${value}`) : "";
}

export default function Difficulty({
	value,
	showLabel = false,
	size = "normal",
	onChange,
} : IDifficulty) {
	if (!value && !onChange) {
		return <span className="difficulty">–</span>;
	}

	const label = getDifficultyLabel(value);

	return <span className={`difficulty ${size === "normal" ? "" : `difficulty--${size}`}`} title={onChange ? undefined : label}>
		<span className="difficulty__hats">
			{Array.from({ length: MAX_DIFFICULTY }, (_item, ind) => onChange
				? <button type="button" className="difficulty__button" key={ind} title={getDifficultyLabel(ind + 1)} aria-label={getDifficultyLabel(ind + 1)} onClick={() => onChange(ind + 1)}>
					<ChefHat filled={ind < value} />
				</button>
				: <ChefHat key={ind} filled={ind < value} />)}
		</span>
		{ showLabel && <span className="difficulty__label">{label}</span> }
	</span>;
}
